// extracted by mini-css-extract-plugin
module.exports = {"terms":"Un","disabled":"Vn","termsCheckbox":"Wn","signUpButton":"Xn","learnMoreButton":"Yn","buttonRow":"Zn","readFaqLink":"_n"};